import { ApiTracksaleRepository } from 'repository/api-tracksale-repository'
import { ApiResponse } from 'service/protocols/api-tracksale/api-tracksale-client'
import {
  IApiTracksaleRepository,
  RepositoryRequest
} from 'service/protocols/api-tracksale/api-tracksale-repository'
import { GetStorage } from 'service/protocols/cache/get-storage'
import { getEnv } from 'infra/config/env'

export class PrepareApiRequestTracksaleDecorator
  implements IApiTracksaleRepository
{
  constructor(
    private readonly getStorage: GetStorage,
    private readonly apiTracksaleRepository: ApiTracksaleRepository
  ) {}

  async post(data: RepositoryRequest): Promise<ApiResponse> {
    data.url =
      process.env.NODE_ENV === 'production'
        ? `/api-tracksale${data.url}`
        : `${getEnv('REACT_APP_API_TRACKSALE_URL') + data.url}`

    return await this.apiTracksaleRepository.post(data)
  }
}
